export default {
	props: {
		id: {type: String, required: false, default: ''},
		value: {type: [String, Boolean, Number, Date, Array, Object], required: false, default: ''},
		name: {type: String, required: false, default: ''},
		readonly: {type: Boolean, required: false, default: false},
		disabled: {type: Boolean, required: false, default: false},
		required: {type: Boolean, required: false, default: false},
		inputClassList: {type: [String, Array, Object], required: false, default: ''},
		autocomplete: {type: String, required: false, default: 'off'},
		placeholder: {type: String, required: false, default: ''},
		classPrefix: {type: String, required: false, default: ''}
	},

	data() {
		return {
			inputValue: null,
			hasFocus: false
		};
	},

	computed: {
		readonlyLive() {
			return this.readonly;
		},

		disabledLive() {
			return this.disabled;
		},

		requiredLive() {
			return this.required;
		},

		inputClassListLive() {
			return this.inputClassList;
		}
	},

	watch: {
		value: {
			immediate: true,
			handler(newValue, oldValue) {
				if (newValue !== oldValue) {
					this.inputValue = newValue;
				}
			}
		},

		inputValue(newValue, oldValue) {
			this.$emit('input', newValue);
		}
	},

	created() {
		this.inputValue = this.value;
	},

	methods: {
		onChangeHandler(event) {
			this.$emit('change', this.inputValue);
		},

		onInputHandler(event) {

		},

		onFocusHandler(event) {
			this.hasFocus = true;
			this.$emit('focus', this.inputValue);
		},

		onBlurHandler(event) {
			this.hasFocus = false;
			this.$emit('blur', this.inputValue);
		}
	}
};
